import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import JoditEditor from "jodit-react";
import { Row, Col, Modal, Card, Container } from "react-bootstrap";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../shared/HelpModal";
import HelpContext from "../shared/context/HelpProvider";
import BhinaMeetingCalendarModal from "./BhinaMeetingCalendarModal";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Edit({
  visible,
  newM,
  setNewM,
  setMeeting,
  mekhraz_id,
  mekhraz,
  setMekhraz,
  newRecord,
  setNewRecord,
  lastTenMeetings,
}) {
  const getLocalTime = (date) => {
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60 * 1000);
    return localDate.toISOString().slice(0, 16);
  };
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const [showMeetingsCalender, setShowMeetingsCalender] = useState(false);
  const [places, setPlaces] = useState([]);
  const [showMeetings, setShowMeetings] = useState(false);
  const [showUpdatePermitDate, setShowUpdatePermitDate] = useState(false);
  // const [displaySave, setDisplaySave] = useState(true);
  const [changed, setChanged] = useState(false);
  const isSubmitting = useRef(false); // Use ref instead of state
  const [mekhrazPermitDate, setMekharazPermitDate] = useState(
    getLocalTime(new Date(Date.now() + 3600 * 1000))
  );
  const editor1 = useRef(null);
  const editor2 = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false,
      height: 400,
      width: 600,
      askBeforePasteFromWord: false,
      askBeforePasteHTML: false,
      //colorPickerDefaultTab: "background",
      //buttons: ["brush"],
      toolbarAdaptive: false,
      disablePlugins: ["File", "Image", "Media"],
    }),
    []
  );

  if (newM == null) {
    setNewM((prevState) => ({
      ...prevState,
      mekhraz: mekhraz_id,
    }));
  }
  useEffect(() => {
    const controller = new AbortController();

    const getPlaces = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "place/", {
          signal: controller.signal,
        });
        setPlaces(response.data);
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };

    getPlaces();

    return () => {
      controller.abort();
    };
  }, []);

  const bhinaMeetingsCalender = (e) => {
    setShowMeetingsCalender(true);
  };

  const handleDDSChange = (e) => {
    const { name, value } = e.target;
    const n = Number(value);
    setChanged(true);
    setNewM((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewM((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setChanged(true);
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault(); // Prevent form from submitting when called by submit event
    }
    let isMounted = true;
    setChanged(false);
    console.log("in submit");
    const controller = new AbortController();
    if (newRecord === 0) {
      console.log("newRecord === 0");
      const saveData = async () => {
        try {
          const response = await axiosPrivate.post(
            baseURL + "bhinameeting/",
            newM
          );
          if (isMounted) {
            setNewM(response.data);
            setMeeting(response.data);
            setNewRecord((prevCount) => prevCount + 1);
            alert("הישיבה נוצרה בהצלחה.");
          }
        } catch (err) {
          if (err.response) {
            alert(HandleHttpErrors(err.response.status));
            if (err.response.status === 401) {
              navigate("/login", { state: { from: location }, replace: true });
            } else if (err.response.status === 403) {
              alert(HandleHttpErrors(err.response.status));
            }
            console.log(err.response);
          } else if (err.request) {
            alert(
              " The client never received a response, and the request was never left"
            );
            console.log(err.request);
          } else {
            console.log(err);
            alert(" Anything else");
          }
        }
      };

      saveData();
      setChanged(false);
      isSubmitting.current = false;
    } else {
      const updateData = async () => {
        try {
          console.log("newRecord !== 0:", newM.notes);
          await axiosPrivate.put(
            baseURL + "bhinameeting/" + newM.id + "/",
            newM
          );
          if (isMounted) {
            alert("העדכון בוצע.");
          }
        } catch (err) {
          if (err.response) {
            alert(HandleHttpErrors(err.response.status));
            if (err.response.status === 401) {
              navigate("/login", { state: { from: location }, replace: true });
            } else if (err.response.status === 403) {
              alert(HandleHttpErrors(err.response.status));
            }
            console.log(err.response);
          } else if (err.request) {
            alert(
              " The client never received a response, and the request was never left"
            );
            console.log(err.request);
          } else {
            console.log(err);
            alert(" Anything else");
          }
        }
      };

      if (newM.end_time <= newM.start_time) {
        alert("זמן סיום הישיבה חייב להיות גדול מזמן ההתחלה.");
        return;
      }

      updateData();
      setChanged(false);
      isSubmitting.current = false;
    }

    setMeeting(newM);
    //setDisplaySave(true);
    setChanged(false);
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  const SubmitPermitionDate = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    // Update `mekhraz` state and proceed with the updated state immediately
    setMekhraz((prevState) => {
      const updatedMekhraz = {
        ...prevState,
        permit_view_for_members: mekhrazPermitDate,
      };

      // Call saveData with the updated state
      saveData(updatedMekhraz);

      return updatedMekhraz;
    });

    const saveData = async (updatedMekhraz) => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "mekhraz/" + mekhraz_id + "/",
          updatedMekhraz, // Use the updated state
          {
            signal: controller.signal,
          }
        );

        if (isMounted) {
          alert("זמן פתיחת מסמכי המועמדים לחברי הוועדה עודכן בהצלחה");
          setShowUpdatePermitDate(false);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    return () => {
      isMounted = false;
      if (isMounted) controller.abort();
    };
  };

  if (!visible) return null;

  return (
    <>
      {showMeetingsCalender && (
        <BhinaMeetingCalendarModal
          showMeetingsCalender={showMeetingsCalender}
          setShowMeetingsCalender={setShowMeetingsCalender}
        />
      )}
      <Modal
        show={showMeetings}
        onHide={() => setShowMeetings(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center w-100">
            מספרי הישיבות האחרונות
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-striped table-bordered text-center">
            <thead className="thead-light">
              <tr>
                <th>מספר הישיבה</th>
                <th>תאריך הישיבה</th>
                <th>מספר המכרז</th>
              </tr>
            </thead>
            <tbody>
              {lastTenMeetings?.map((item) => (
                <tr key={item.mt_num}>
                  <td>{item.mt_num}</td>
                  <td>{item.mt_date}</td>
                  <td>{item.mkh_num}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <button
            className="btn btn-secondary"
            onClick={() => setShowMeetings(false)}
          >
            סגור
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showUpdatePermitDate} backdrop="static" keyboard={false}>
        <Modal.Header style={{ textAlign: "center" }}>
          <Modal.Title>
            {"פתיחת הצעות המועמדים לעיון חברי הוועדה"}
            <br />
            <label style={{ color: "blue" }}>
              {mekhraz?.permit_view_for_members ? (
                <>
                  המכרז נפתח בעבר עד:{" "}
                  {new Date(mekhraz.permit_view_for_members).toLocaleString(
                    "he-IL",
                    { dateStyle: "short", timeStyle: "short" }
                  )}
                </>
              ) : (
                <>לא נפתח בעבר לעיון חברי הוועדה</>
              )}
            </label>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="form-group"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <label>עד</label>
            <input
              type="date"
              name="permit_date"
              className="form-control"
              id="permit_date"
              value={mekhrazPermitDate.split("T")[0]} // Extract the date part
              disabled
              style={{
                width: "100%",
                maxWidth: "300px",
                padding: "10px 15px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                marginBottom: "8px", // Spacing between inputs
              }}
            />

            <input
              type="time"
              name="permit_time"
              className="form-control styled-input"
              id="permit_time"
              value={mekhrazPermitDate.split("T")[1]?.slice(0, 5)} // Extract the time in HH:mm format
              onChange={(event) => {
                const date = mekhrazPermitDate.split("T")[0]; // Extract the date part
                const time = event.target.value; // Get the time from input
                setMekharazPermitDate(`${date}T${time}`); // Update the state with the new value
              }}
              style={{
                width: "100%",
                maxWidth: "300px",
                padding: "10px 15px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                transition: "border-color 0.3s, box-shadow 0.3s",
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <button
            className="btn btn-primary"
            onClick={(event) => SubmitPermitionDate(event)}
            style={{ marginLeft: "auto" }} // Pushes the button to the right
          >
            אישור
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              setShowUpdatePermitDate(false);
            }}
            style={{ marginRight: "auto" }} // Pushes the button to the left
          >
            בטל
          </button>
        </Modal.Footer>
      </Modal>

      <Container style={{ height: "calc(100vh - 40px)", overflowY: "scroll" }}>
        <HelpModal />
        <Card className="border-warning container px-5 " bg="light">
          <Card.Header>
            <div style={{ textAlign: "center" }}>
              <h3
                onClick={() => {
                  setSaeef("26");
                  setShowHelp(true);
                }}
              >
                הוספת/עריכת ישיבה
                <span className="help">
                  <MdLiveHelp />
                </span>
              </h3>
              <div
                className="button-group"
                style={{ textAlign: "center", marginTop: "20px" }}
              >
                <button
                  className="btn btn-info mx-2"
                  style={{ display: "inline-flex", alignItems: "center" }}
                  onClick={() => setShowMeetings(true)}
                >
                  <i className="fas fa-calendar-alt me-2"></i>
                  הצגת מספרי 10 הישיבות האחרונות הקיימות במערכת
                </button>

                <button
                  onClick={bhinaMeetingsCalender}
                  className="btn btn-info mx-2"
                  style={{ display: "inline-flex", alignItems: "center" }}
                >
                  <i className="fas fa-calendar-check me-2"></i>
                  הצג מועדי ישיבות הבחינה
                </button>

                <button
                  className="btn btn-success mx-2"
                  style={{ display: "inline-flex", alignItems: "center" }}
                  onClick={() => setShowUpdatePermitDate(true)}
                >
                  <i className="fas fa-users me-2"></i>
                  אפשר הצגת הצעות המועמדים לחברי הוועדה
                </button>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <label htmlFor="mt_num">מספר הישיבה </label>
                  <input
                    type="text"
                    name="mt_num"
                    defaultValue={newM?.mt_num}
                    onChange={handleChange}
                    className="form-control"
                    id="mt_num"
                    placeholder=""
                    required
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="mt_date">תאריך הישיבה </label>
                  <input
                    type="date"
                    name="mt_date"
                    value={newM?.mt_date}
                    onChange={handleChange}
                    className="form-control"
                    id="mt_date"
                    placeholder=""
                    required
                  />
                </Col>
                <Col>
                  <label htmlFor="start_time">זמן התחלה </label>
                  <input
                    type="time"
                    name="start_time"
                    value={newM?.start_time}
                    onChange={handleChange}
                    className="form-control"
                    id="start_time"
                    placeholder=""
                    required
                  />
                </Col>
                <Col>
                  <label htmlFor="end_time">זמן סיום </label>
                  <input
                    type="time"
                    name="end_time"
                    value={newM?.end_time}
                    onChange={handleChange}
                    className="form-control"
                    id="end_time"
                    placeholder=""
                  />
                  <br />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="form-group">
                    <label htmlFor="place">מקום:</label>
                    <br />
                    <select
                      name="place"
                      onChange={handleDDSChange}
                      value={newM?.place}
                      required
                    >
                      <option value="" selected>
                        בחר מקום
                      </option>
                      {places?.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="hazmana_notes"> הערות שיופיעו בהזמנה </label>
                  <JoditEditor
                    editorRef={editor2}
                    tabIndex={2}
                    name="hazmana_notes"
                    value={newM?.hazmana_notes}
                    config={config}
                    onBlur={(newContent) => {
                      //setDisplaySave(false);
                      console.log("hazmana notes content", newContent);
                      setNewM((prevState) => ({
                        ...prevState,
                        hazmana_notes: newContent,
                      }));
                      //setDisplaySave(false);
                    }}
                    onChange={(newContent) => {
                      if (newM && newM?.hazmana_notes !== newContent) {
                        console.log("hazmana_notes");
                        setChanged(true);
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <label htmlFor="notes">הערות כלליות </label>
                  <JoditEditor
                    editorRef={editor2}
                    tabIndex={2}
                    name="notes"
                    value={newM?.notes}
                    config={config}
                    onBlur={(newContent) => {
                      //setDisplaySave(false);
                      setNewM((prevState) => ({
                        ...prevState,
                        notes: newContent,
                      }));
                      //setDisplaySave(false);
                    }}
                    onChange={(newContent) => {
                      if (newM && newM?.notes !== newContent) {
                        console.log("hazmana_notes");
                        setChanged(true);
                      }
                    }}
                  />
                </Col>
              </Row>
              <br></br>
              <button
                type="submit"
                className="btn btn-primary"
                //disabled = { displaySave }
                onClick={() => {
                  isSubmitting.current = true;
                  setChanged(false);
                }}
              >
                שמור
              </button>
            </form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
